export const areSwitchRowCountsUsable = ({
  numOfUOS,
  numOfSSR,
  numSwitches,
}) => {
  const uosCount = Number(numOfUOS);
  const ssrCount = Number(numOfSSR);
  const switchCount = Number(numSwitches);

  return (
    Number.isInteger(uosCount) &&
    uosCount > 0 &&
    Number.isInteger(ssrCount) &&
    ssrCount >= 0 &&
    Number.isInteger(switchCount) &&
    switchCount > 0
  );
};
